import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import Document from "src/components/Document/Document";
// ----------------------------------------------------------------------

export default function SalesHRADocument() {
  return (
    <>
      <Helmet>
        <title> SalesDocument </title>
      </Helmet>

      <Container maxWidth="xl">
        <Document Role="Sales-HRA" />
      </Container>
    </>
  );
}
